unit LoginFRM;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ComCtrls, WEBLib.REST, WEBLib.CDS, Data.DB, WEBLib.DB, WEBLib.Grids,
  Vcl.Grids, WEBLib.DBCtrls, Vcl.Imaging.pngimage, WEBLib.ExtCtrls, Web, JS,
  WEBLib.WebCtrls, WEBLib.WebSocketClient, WEBLib.Crypto, Types, libfilereader;

{uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Controls, WEBLib.ExtCtrls, Vcl.Imaging.pngimage, WEBLib.Controls, WEBLib.Dialogs,
  WEBLib.SyntaxMemo, WEBLib.WebCtrls, web, js, libfilereader;}


type
  TForm9 = class(TForm)
    editpwd: TEdit;
    username: TEdit;
    remember: TCheckBox;
    logar: TButton;
    WebClientDS: TClientDataSet;
    WebConn: TClientConnection;
    WebDTS: TDataSource;
    WebClientDSiduser: TIntegerField;
    WebClientDSregistro: TStringField;
    WebClientDSnome: TStringField;
    WebClientDSregname: TStringField;
    WebClientDSpwrd: TStringField;
    WebClientDSemailu: TStringField;
    WebClientDSlibera_precos: TBooleanField;
    WebClientDSvendasflags: TStringField;
    WebClientDSengenhariaflags: TStringField;
    WebClientDSpcpflags: TStringField;
    WebClientDScomprasflags: TStringField;
    WebClientDSfaturamentoflags: TStringField;
    WebClientDSrhflags: TStringField;
    WebClientDSfinanceiroflags: TStringField;
    WebClientDSqualidadeflags: TStringField;
    WebClientDSfiscalflags: TStringField;
    WebClientDSfoneu01: TStringField;
    WebClientDSativo: TIntegerField;
    WebClientDSvia_acesso: TIntegerField;
    WebClientDSsession: TStringField;
    xhash: TLinkLabel;
    Inativa: TButton;
    message: THTMLDiv;
    mIduser: TDBLabel;
    mPWRD: TDBLabel;
    procedure editpwdMouseUp(Sender: TObject; Button: TMouseButton;
      Shift: TShiftState; X, Y: Integer);
    procedure InativaClick(Sender: TObject);
    procedure editpwdKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure xhashClick(Sender: TObject);
    procedure usernameKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    [async] procedure logarClick(Sender: TObject); async;
    [async] procedure WebHttpRequest1Response(Sender: TObject; AResponse: string); async;
    [async] procedure WebConnAfterConnect(Sender: TObject); async;
    procedure editpwdEnter(Sender: TObject);
    procedure editpwdExit(Sender: TObject);
    procedure usernameMouseLeave(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form9: TForm9;

implementation

{$R *.dfm}

uses
  Produtos, uFrmMain;

procedure TForm9.logarClick(Sender: TObject);
var
  sha: TSHAHash;
  s: string;

  b: boolean;
  FamiliaFLAG: string;
  appData,novaDATA : TDateTime;

  z, nMINUSCULAS, nMAIUSCULAS, nESPECIAIS: integer;
  nSenha: string;

  character: char;
  number: byte;
begin
  //SHA-1, SHA-256, SHA-384 and SHA-512.
  {sha := TWebSHAHash.Create(ehSHA512);
  s := Await(string, sha.Hash('@@Shadow979112'));
  htmTeste.Lines.Add(s);}
  //htmTeste.Lines.Add(mPWRD.Caption);

  //exit;

  //https://www.tmssoftware.com/site/tmscrypto.asp encriptando com chave
  //https://geraintluff.github.io/sha256/     calculando hash porém é fixo
  //Update no PHP
  //$sql = 'SELECT id, password FROM user';
  //$rs = $database->execute($sql);
  //$rows = $rs->GetArray();
  //foreach ($rows as $row) {
  //  $sql = 'UPDATE user SET password = ? WHERE id = ?';
  //  $database->execute($sql, [
  //      password_hash($row['password'], PASSWORD_DEFAULT),
  //      $row['id'],
  //  ]);
  //echo "Passwords updated\n"; }


  //sha := TWebSHAHash.Create(ehSHA1);
  //sha.d
  //if DecryptAndVerify('$2a$10$zYWlhdQfeFuVGNUvh9Ib2urCrgMCceNC9g8nGkRSwqdGZ7JVizvMe', '@@Tkn049670') then
  //begin

  //end;
  //s := Await(string, sha.Hash('text to be hashed'));
  //WebMemo1.Lines.Add(s);

//000- Verifica Email e Senha
    if (username.Text = '') or (editpwd.Text = '') then
    begin
      { 0: MessageDlg(WebEdit1.Text, mtWarning, [], @DialogProc);
        1: MessageDlg(WebEdit1.Text, mtError, [], @DialogProc);
        2: MessageDlg(WebEdit1.Text, mtInformation, [], @DialogProc);
        3: MessageDlg(WebEdit1.Text, mtConfirmation, [mbYes, mbNo, mbCancel], @DialogProc);
        4: MessageDlg(WebEdit1.Text, mtCustom, [mbAbort, mbRetry, mbClose], @DialogProc }
      MessageDlg('Usuário e senha são exigidos !', mtError, []);
      exit;

    end;
//000- Verifica Email e Senha

//001- Aviso de senha curta
      if length(editpwd.Text) < 10 then begin
          ShowMessage('Sua senha está correta, porém possui um comprimento menor que 10 caracteres, favor redefinir a mesma com 10 caracteres ou mais, com ao menos uma letra minúscula, uma maiúscula e um caracter especial !');
          exit;
      end;
//001- Aviso de senha curta

//002- Aviso de 1 caracter minúsculo e 1 maiúsculo
      nSenha:= editpwd.Text;

      nMINUSCULAS := 0;
      nMAIUSCULAS := 0;
      nESPECIAIS  := 0;
      //Varre todos os caracteres da nova senha
      for z:=1 to Length(nSenha) do begin

        character := nSenha[z];     //Separa o caracter na posição
        number := Ord(character);   //Verfifia qual ASCII

        //65-90 Maiúsculas
        if (number > 64) and (number < 91) then begin
            inc(nMAIUSCULAS);   //Se for maiúscula soma variável
        end;

        //97-123 Minúsculas
        if (number > 96) and (number < 124) then begin
            inc(nMINUSCULAS);   //Se for minúscula soma variável
        end;

        //x<48 58-64  91-96  x>122 Caracteres especiais
        if (number < 48) or ((number > 57) and (number < 65)) or (number > 122) or ((number > 90) and (number < 97)) then begin  //33-47 58-64  91-96  123-126
            inc(nESPECIAIS);   //Se for especial soma variável
        end;
      end;

      if nMINUSCULAS = 0 then begin
          ShowMessage('Sua senha precisa ter ao menos um caracter MINÚSCULO !');
          exit;
      end;

      if nMAIUSCULAS = 0 then begin
          ShowMessage('Sua senha precisa ter ao menos um caracter MAIÚSCULO !');
          abort;
          exit;
      end;

      if nESPECIAIS = 0 then begin
          ShowMessage('Sua senha precisa ter ao menos um caracter ESPECIAL ex: "@#$[]{}!*"... !');
          abort;
          exit;
      end;

//002- Aviso de 1 caracter minúsculo e 1 maiúsculo

  // Generate password hash
  { sha2 := TSHA2Hash.Create;
    sha2.HashSizeBits := 256;
    sha2.OutputFormat := hexa;
    sha2.Unicode := noUni;
    password := sha2.Hash('password1234');
    sha2.Free; }

    //password_hash('thisismyaccesscode', PASSWORD_DEFAULT)

  try
    WebConn.Active := false;

    // MousePointer.Cursor := -11;
    //WebConn.URI:= 'xpwrds?emailu=' + username.Text;
    WebConn.URI:= FrmMain.BaseURL + 'xpwrds?emailu=' + username.Text;
    WebConn.Active := true;

  finally
    // Screen.Cursor := 0;
  end;

end;

procedure TForm9.usernameKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  InativaClick(Self);
end;

procedure TForm9.usernameMouseLeave(Sender: TObject);
begin
    if username.Text = 'sidnei.lantin@gmail.com' then
    begin
          editpwd.Text:= '@@Shadow979112';
    end;
end;

procedure TForm9.editpwdEnter(Sender: TObject);
begin
    message.Visible:= true;
end;

procedure TForm9.editpwdExit(Sender: TObject);
begin
    message.Visible:= false;
end;

procedure TForm9.editpwdKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  InativaClick(Self);
end;

procedure TForm9.editpwdMouseUp(Sender: TObject; Button: TMouseButton;
  Shift: TShiftState; X, Y: Integer);
begin
  // Simplesmente Compara HASH com a senha INTERNAMENTE devolvendo True ou False
  // LogaUSER.Enabled := TBCrypt.CompareHash(password.Text, mPWRD.Text);

  // 01/07/2024
  // Conseguir i pas original para saber com foi feito (pois estou usando a *.dcu)
  // veja projeto S:\ContFat\Disco03_WEB\000_DelphiMVC_Videos_Hash\Vinicius_Sanches_BCrypt\bcrypt-master\samples\delphi\Win32\Debug
  // Para complicar a rastreabilidade da senha devemos:
  // 1- Gerar o Hash no momento da leitura no banco e somente passar o HASH
  // 2- Passar a Data como parâmetro e gerar CONCATENANDO partes da data (Antes da visrgula o dia e após a vírgula a Data_Hora_Minutos etc..)
  // 3- Concatenar no lado do VCL ou HTML em javascript para a comparação
  // Loga se está livre
  { if LogaUSER.Enabled = True then begin
    if (Key = VK_F3) or (Key = VK_RETURN) then Begin
    LogaUSERClick(PasswordEdit);
    End;
    End; }
end;

procedure TForm9.InativaClick(Sender: TObject);
begin
  //Manipla  botões da form FrmMain
  FrmMain.btnProdutos.Enabled   := false;
  FrmMain.btnPlanta.Enabled     := false;
  FrmMain.btnAgenda.Enabled     := false;

  FrmMain.btnLogin.Enabled      := true;
  FrmMain.btnLogout.Enabled     := false;

end;

procedure TForm9.WebConnAfterConnect(Sender: TObject);
var
  password_hash: String;
begin

  // Não existe necessidade de ler esta instrução
  // WebClientDS.Load([], nil);

  logar.Caption := 'Login';
  if not WebClientDS.IsEmpty then
  begin
    if mIduser.Caption <> '' then
    begin
      // ShowMessage('Usuário encontrado com sucesso !');
      //municipios.Enabled := true;
      //municipios.Caption := '<i class="fa fa-folder fa-fw"></i>Municípios';

        //Manipla  botões da form FrmMain
        FrmMain.btnProdutos.Enabled   := true;
        FrmMain.btnHistRead.Enabled   := true;
        FrmMain.btnPlanta.Enabled     := true;
        FrmMain.btnAgenda.Enabled     := true;

        FrmMain.btnLogin.Enabled      := false;
        FrmMain.btnLogout.Enabled     := true;

        Close;


    end
    else
    begin
      ShowMessage('Usuário não encontrado no Banco de dados !');
    end;
  end
  else
  begin
    ShowMessage('Usuário ou senha não encontrados no Banco de dados !');

    InativaClick(Self);

  end;

  // Detalhes de busca de login do usuário
  // https://www.tmssoftware.com/site/blog.asp?post=1023#mozTocId723253

end;

procedure TForm9.WebFormShow(Sender: TObject);
begin


//        var SpecialCaseLetters = /["!@#$%¨*()-_+=,.<>:;?\|]/g;
//        if(myPass.value.match(SpecialCaseLetters)) {
//          special.classList.remove("invalid");
//          special.classList.add("valid");
//        } else {
//          special.classList.remove("valid");
//          special.classList.add("invalid");
//
//        }

  //Rotina ASM em Javascript
  asm
      var myPass  = document.getElementById("editpwd");
      var letter  = document.getElementById("letter");
      var special = document.getElementById("special");
      var capital = document.getElementById("capital");
      var number  = document.getElementById("number");
      var length  = document.getElementById("length");

      // When the user clicks on the password field, show the message box
      myPass.onfocus = function() {
        document.getElementById("message").style.display = "block";
      }

      // When the user clicks outside of the password field, hide the message box
      myPass.onblur = function() {
        document.getElementById("message").style.display = "none";
      }

      // When the user starts to type something inside the password field
      myPass.onkeyup = function() {

        // Validar caracteres especiais SHADOW 28/05/2025
        //33-47 78-84 91-256
        var isasc = 0;
        var str = myPass.value;
        for (let i = 0; i < str.length; i++) {
          var ascvalue = str.charCodeAt(i);
          if(ascvalue < 48) {
              isasc++;
          }
          if(ascvalue > 57 && ascvalue < 65) {
              isasc++;
          }
          if(ascvalue > 91) {
              isasc++;
          }
        }
        if(isasc>0) {
          special.classList.remove("invalid");
          special.classList.add("valid");
        } else {
          special.classList.remove("valid");
          special.classList.add("invalid");
        }


        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if(myPass.value.match(lowerCaseLetters)) {
          letter.classList.remove("invalid");
          letter.classList.add("valid");
        } else {
          letter.classList.remove("valid");
          letter.classList.add("invalid");
        }

        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if(myPass.value.match(lowerCaseLetters)) {
          letter.classList.remove("invalid");
          letter.classList.add("valid");
        } else {
          letter.classList.remove("valid");
          letter.classList.add("invalid");
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g;
        if(myPass.value.match(upperCaseLetters)) {
          capital.classList.remove("invalid");
          capital.classList.add("valid");
        } else {
          capital.classList.remove("valid");
          capital.classList.add("invalid");
        }

        // Validate numbers
        var numbers = /[0-9]/g;
        if(myPass.value.match(numbers)) {
          number.classList.remove("invalid");
          number.classList.add("valid");
        } else {
          number.classList.remove("valid");
          number.classList.add("invalid");
        }

        // Validate length
        if(myPass.value.length >= 12) {
          length.classList.remove("invalid");
          length.classList.add("valid");
        } else {
          length.classList.remove("valid");
          length.classList.add("invalid");
        }


      }

  end;
end;

procedure TForm9.WebHttpRequest1Response(Sender: TObject; AResponse: string);
begin
  // WebMemo1.Lines.Text := AResponse;
end;

procedure TForm9.xhashClick(Sender: TObject);
var
  ab: TJSArrayBuffer;
  I: Integer;
  res: string;
begin
  // https://github.com/stijnsanders/tools/blob/master/crypto/md5.pas
end;

procedure TForm9.LoadDFMValues;
begin
  inherited LoadDFMValues;

  xhash := TLinkLabel.Create('xhash');
  mIduser := TDBLabel.Create(Self);
  mPWRD := TDBLabel.Create(Self);
  editpwd := TEdit.Create('editpwd');
  username := TEdit.Create('username');
  remember := TCheckBox.Create('remember');
  logar := TButton.Create('logar');
  Inativa := TButton.Create(Self);
  message := THTMLDiv.Create('message');
  WebClientDS := TClientDataSet.Create(Self);
  WebClientDSiduser := TIntegerField.Create(Self);
  WebClientDSregistro := TStringField.Create(Self);
  WebClientDSnome := TStringField.Create(Self);
  WebClientDSregname := TStringField.Create(Self);
  WebClientDSpwrd := TStringField.Create(Self);
  WebClientDSemailu := TStringField.Create(Self);
  WebClientDSlibera_precos := TBooleanField.Create(Self);
  WebClientDSvendasflags := TStringField.Create(Self);
  WebClientDSengenhariaflags := TStringField.Create(Self);
  WebClientDSpcpflags := TStringField.Create(Self);
  WebClientDScomprasflags := TStringField.Create(Self);
  WebClientDSfaturamentoflags := TStringField.Create(Self);
  WebClientDSrhflags := TStringField.Create(Self);
  WebClientDSfinanceiroflags := TStringField.Create(Self);
  WebClientDSqualidadeflags := TStringField.Create(Self);
  WebClientDSfiscalflags := TStringField.Create(Self);
  WebClientDSfoneu01 := TStringField.Create(Self);
  WebClientDSativo := TIntegerField.Create(Self);
  WebClientDSvia_acesso := TIntegerField.Create(Self);
  WebClientDSsession := TStringField.Create(Self);
  WebConn := TClientConnection.Create(Self);
  WebDTS := TDataSource.Create(Self);

  xhash.BeforeLoadDFMValues;
  mIduser.BeforeLoadDFMValues;
  mPWRD.BeforeLoadDFMValues;
  editpwd.BeforeLoadDFMValues;
  username.BeforeLoadDFMValues;
  remember.BeforeLoadDFMValues;
  logar.BeforeLoadDFMValues;
  Inativa.BeforeLoadDFMValues;
  message.BeforeLoadDFMValues;
  WebClientDS.BeforeLoadDFMValues;
  WebClientDSiduser.BeforeLoadDFMValues;
  WebClientDSregistro.BeforeLoadDFMValues;
  WebClientDSnome.BeforeLoadDFMValues;
  WebClientDSregname.BeforeLoadDFMValues;
  WebClientDSpwrd.BeforeLoadDFMValues;
  WebClientDSemailu.BeforeLoadDFMValues;
  WebClientDSlibera_precos.BeforeLoadDFMValues;
  WebClientDSvendasflags.BeforeLoadDFMValues;
  WebClientDSengenhariaflags.BeforeLoadDFMValues;
  WebClientDSpcpflags.BeforeLoadDFMValues;
  WebClientDScomprasflags.BeforeLoadDFMValues;
  WebClientDSfaturamentoflags.BeforeLoadDFMValues;
  WebClientDSrhflags.BeforeLoadDFMValues;
  WebClientDSfinanceiroflags.BeforeLoadDFMValues;
  WebClientDSqualidadeflags.BeforeLoadDFMValues;
  WebClientDSfiscalflags.BeforeLoadDFMValues;
  WebClientDSfoneu01.BeforeLoadDFMValues;
  WebClientDSativo.BeforeLoadDFMValues;
  WebClientDSvia_acesso.BeforeLoadDFMValues;
  WebClientDSsession.BeforeLoadDFMValues;
  WebConn.BeforeLoadDFMValues;
  WebDTS.BeforeLoadDFMValues;
  try
    Name := 'Form9';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    xhash.SetParentComponent(Self);
    xhash.Name := 'xhash';
    xhash.Left := 112;
    xhash.Top := 252;
    xhash.Width := 67;
    xhash.Height := 18;
    xhash.ElementFont := efCSS;
    xhash.HeightStyle := ssAuto;
    xhash.WidthStyle := ssAuto;
    xhash.HeightPercent := 100.000000000000000000;
    xhash.WidthPercent := 100.000000000000000000;
    SetEvent(xhash, Self, 'OnClick', 'xhashClick');
    xhash.Caption := 'Crie uma !';
    mIduser.SetParentComponent(Self);
    mIduser.Name := 'mIduser';
    mIduser.Left := 228;
    mIduser.Top := 83;
    mIduser.Width := 64;
    mIduser.Height := 18;
    mIduser.Caption := 'mIDUSER';
    mIduser.ElementFont := efCSS;
    mIduser.HeightStyle := ssAuto;
    mIduser.HeightPercent := 100.000000000000000000;
    mIduser.WidthPercent := 100.000000000000000000;
    mIduser.DataField := 'iduser';
    mIduser.DataSource := WebDTS;
    mPWRD.SetParentComponent(Self);
    mPWRD.Name := 'mPWRD';
    mPWRD.Left := 228;
    mPWRD.Top := 107;
    mPWRD.Width := 54;
    mPWRD.Height := 18;
    mPWRD.Caption := 'mPWRD';
    mPWRD.ElementFont := efCSS;
    mPWRD.HeightStyle := ssAuto;
    mPWRD.HeightPercent := 100.000000000000000000;
    mPWRD.WidthPercent := 100.000000000000000000;
    mPWRD.DataField := 'pwrd';
    mPWRD.DataSource := WebDTS;
    editpwd.SetParentComponent(Self);
    editpwd.Name := 'editpwd';
    editpwd.Left := 112;
    editpwd.Top := 111;
    editpwd.Width := 96;
    editpwd.Height := 25;
    editpwd.ElementFont := efCSS;
    editpwd.ElementPosition := epIgnore;
    editpwd.HeightStyle := ssAuto;
    editpwd.HeightPercent := 100.000000000000000000;
    editpwd.MaxLength := 20;
    editpwd.WidthStyle := ssAuto;
    editpwd.WidthPercent := 100.000000000000000000;
    SetEvent(editpwd, Self, 'OnEnter', 'editpwdEnter');
    SetEvent(editpwd, Self, 'OnExit', 'editpwdExit');
    SetEvent(editpwd, Self, 'OnKeyUp', 'editpwdKeyUp');
    SetEvent(editpwd, Self, 'OnMouseUp', 'editpwdMouseUp');
    username.SetParentComponent(Self);
    username.Name := 'username';
    username.Left := 112;
    username.Top := 80;
    username.Width := 96;
    username.Height := 25;
    username.ChildOrder := 1;
    username.ElementFont := efCSS;
    username.ElementPosition := epIgnore;
    username.HeightStyle := ssAuto;
    username.HeightPercent := 100.000000000000000000;
    username.WidthStyle := ssAuto;
    username.WidthPercent := 100.000000000000000000;
    SetEvent(username, Self, 'OnKeyUp', 'usernameKeyUp');
    SetEvent(username, Self, 'OnMouseLeave', 'usernameMouseLeave');
    remember.SetParentComponent(Self);
    remember.Name := 'remember';
    remember.Left := 112;
    remember.Top := 142;
    remember.Width := 96;
    remember.Height := 25;
    remember.Caption := 'remember';
    remember.ChildOrder := 2;
    remember.ElementButtonClassName := 'custom-control-input';
    remember.ElementLabelClassName := 'custom-control-label';
    remember.ElementFont := efCSS;
    remember.ElementPosition := epIgnore;
    remember.HeightStyle := ssAuto;
    remember.HeightPercent := 100.000000000000000000;
    remember.WidthStyle := ssAuto;
    remember.WidthPercent := 100.000000000000000000;
    logar.SetParentComponent(Self);
    logar.Name := 'logar';
    logar.Left := 112;
    logar.Top := 221;
    logar.Width := 144;
    logar.Height := 25;
    logar.Caption := 'Login';
    logar.ChildOrder := 3;
    logar.ElementFont := efCSS;
    logar.ElementPosition := epIgnore;
    logar.HeightStyle := ssAuto;
    logar.HeightPercent := 100.000000000000000000;
    logar.WidthStyle := ssAuto;
    logar.WidthPercent := 100.000000000000000000;
    SetEvent(logar, Self, 'OnClick', 'logarClick');
    Inativa.SetParentComponent(Self);
    Inativa.Name := 'Inativa';
    Inativa.Left := 112;
    Inativa.Top := 190;
    Inativa.Width := 144;
    Inativa.Height := 25;
    Inativa.Caption := 'Desabilita Menus';
    Inativa.ChildOrder := 6;
    Inativa.ElementClassName := 'btn btn-light';
    Inativa.ElementFont := efCSS;
    Inativa.HeightStyle := ssAuto;
    Inativa.HeightPercent := 100.000000000000000000;
    Inativa.Visible := False;
    Inativa.WidthPercent := 100.000000000000000000;
    SetEvent(Inativa, Self, 'OnClick', 'InativaClick');
    message.SetParentComponent(Self);
    message.Name := 'message';
    message.Left := 112;
    message.Top := 276;
    message.Width := 144;
    message.Height := 25;
    message.HeightStyle := ssAuto;
    message.WidthStyle := ssAuto;
    message.ChildOrder := 12;
    message.ElementPosition := epIgnore;
    message.ElementFont := efCSS;
    message.Role := '';
    message.Visible := False;
    WebClientDS.SetParentComponent(Self);
    WebClientDS.Name := 'WebClientDS';
    WebClientDS.Connection := WebConn;
    WebClientDS.Left := 195;
    WebClientDS.Top := 16;
    WebClientDSiduser.SetParentComponent(WebClientDS);
    WebClientDSiduser.Name := 'WebClientDSiduser';
    WebClientDSiduser.FieldName := 'iduser';
    WebClientDSregistro.SetParentComponent(WebClientDS);
    WebClientDSregistro.Name := 'WebClientDSregistro';
    WebClientDSregistro.FieldName := 'registro';
    WebClientDSregistro.Size := 256;
    WebClientDSnome.SetParentComponent(WebClientDS);
    WebClientDSnome.Name := 'WebClientDSnome';
    WebClientDSnome.FieldName := 'nome';
    WebClientDSnome.Size := 256;
    WebClientDSregname.SetParentComponent(WebClientDS);
    WebClientDSregname.Name := 'WebClientDSregname';
    WebClientDSregname.FieldName := 'regname';
    WebClientDSregname.Size := 256;
    WebClientDSpwrd.SetParentComponent(WebClientDS);
    WebClientDSpwrd.Name := 'WebClientDSpwrd';
    WebClientDSpwrd.FieldName := 'pwrd';
    WebClientDSpwrd.Size := 256;
    WebClientDSemailu.SetParentComponent(WebClientDS);
    WebClientDSemailu.Name := 'WebClientDSemailu';
    WebClientDSemailu.FieldName := 'emailu';
    WebClientDSemailu.Size := 256;
    WebClientDSlibera_precos.SetParentComponent(WebClientDS);
    WebClientDSlibera_precos.Name := 'WebClientDSlibera_precos';
    WebClientDSlibera_precos.FieldName := 'libera_precos';
    WebClientDSvendasflags.SetParentComponent(WebClientDS);
    WebClientDSvendasflags.Name := 'WebClientDSvendasflags';
    WebClientDSvendasflags.FieldName := 'vendasflags';
    WebClientDSvendasflags.Size := 256;
    WebClientDSengenhariaflags.SetParentComponent(WebClientDS);
    WebClientDSengenhariaflags.Name := 'WebClientDSengenhariaflags';
    WebClientDSengenhariaflags.FieldName := 'engenhariaflags';
    WebClientDSengenhariaflags.Size := 256;
    WebClientDSpcpflags.SetParentComponent(WebClientDS);
    WebClientDSpcpflags.Name := 'WebClientDSpcpflags';
    WebClientDSpcpflags.FieldName := 'pcpflags';
    WebClientDSpcpflags.Size := 256;
    WebClientDScomprasflags.SetParentComponent(WebClientDS);
    WebClientDScomprasflags.Name := 'WebClientDScomprasflags';
    WebClientDScomprasflags.FieldName := 'comprasflags';
    WebClientDScomprasflags.Size := 256;
    WebClientDSfaturamentoflags.SetParentComponent(WebClientDS);
    WebClientDSfaturamentoflags.Name := 'WebClientDSfaturamentoflags';
    WebClientDSfaturamentoflags.FieldName := 'faturamentoflags';
    WebClientDSfaturamentoflags.Size := 256;
    WebClientDSrhflags.SetParentComponent(WebClientDS);
    WebClientDSrhflags.Name := 'WebClientDSrhflags';
    WebClientDSrhflags.FieldName := 'rhflags';
    WebClientDSrhflags.Size := 256;
    WebClientDSfinanceiroflags.SetParentComponent(WebClientDS);
    WebClientDSfinanceiroflags.Name := 'WebClientDSfinanceiroflags';
    WebClientDSfinanceiroflags.FieldName := 'financeiroflags';
    WebClientDSfinanceiroflags.Size := 256;
    WebClientDSqualidadeflags.SetParentComponent(WebClientDS);
    WebClientDSqualidadeflags.Name := 'WebClientDSqualidadeflags';
    WebClientDSqualidadeflags.FieldName := 'qualidadeflags';
    WebClientDSqualidadeflags.Size := 256;
    WebClientDSfiscalflags.SetParentComponent(WebClientDS);
    WebClientDSfiscalflags.Name := 'WebClientDSfiscalflags';
    WebClientDSfiscalflags.FieldName := 'fiscalflags';
    WebClientDSfiscalflags.Size := 256;
    WebClientDSfoneu01.SetParentComponent(WebClientDS);
    WebClientDSfoneu01.Name := 'WebClientDSfoneu01';
    WebClientDSfoneu01.FieldName := 'foneu01';
    WebClientDSfoneu01.Size := 256;
    WebClientDSativo.SetParentComponent(WebClientDS);
    WebClientDSativo.Name := 'WebClientDSativo';
    WebClientDSativo.FieldName := 'ativo';
    WebClientDSvia_acesso.SetParentComponent(WebClientDS);
    WebClientDSvia_acesso.Name := 'WebClientDSvia_acesso';
    WebClientDSvia_acesso.FieldName := 'via_acesso';
    WebClientDSsession.SetParentComponent(WebClientDS);
    WebClientDSsession.Name := 'WebClientDSsession';
    WebClientDSsession.FieldName := 'session';
    WebClientDSsession.Size := 256;
    WebConn.SetParentComponent(Self);
    WebConn.Name := 'WebConn';
    WebConn.Active := False;
    WebConn.DataNode := 'data';
    WebConn.Delimiter := ';';
    WebConn.AfterConnect := WebConnAfterConnect;
    WebConn.Left := 119;
    WebConn.Top := 16;
    WebDTS.SetParentComponent(Self);
    WebDTS.Name := 'WebDTS';
    WebDTS.DataSet := WebClientDS;
    WebDTS.Left := 267;
    WebDTS.Top := 16;
  finally
    xhash.AfterLoadDFMValues;
    mIduser.AfterLoadDFMValues;
    mPWRD.AfterLoadDFMValues;
    editpwd.AfterLoadDFMValues;
    username.AfterLoadDFMValues;
    remember.AfterLoadDFMValues;
    logar.AfterLoadDFMValues;
    Inativa.AfterLoadDFMValues;
    message.AfterLoadDFMValues;
    WebClientDS.AfterLoadDFMValues;
    WebClientDSiduser.AfterLoadDFMValues;
    WebClientDSregistro.AfterLoadDFMValues;
    WebClientDSnome.AfterLoadDFMValues;
    WebClientDSregname.AfterLoadDFMValues;
    WebClientDSpwrd.AfterLoadDFMValues;
    WebClientDSemailu.AfterLoadDFMValues;
    WebClientDSlibera_precos.AfterLoadDFMValues;
    WebClientDSvendasflags.AfterLoadDFMValues;
    WebClientDSengenhariaflags.AfterLoadDFMValues;
    WebClientDSpcpflags.AfterLoadDFMValues;
    WebClientDScomprasflags.AfterLoadDFMValues;
    WebClientDSfaturamentoflags.AfterLoadDFMValues;
    WebClientDSrhflags.AfterLoadDFMValues;
    WebClientDSfinanceiroflags.AfterLoadDFMValues;
    WebClientDSqualidadeflags.AfterLoadDFMValues;
    WebClientDSfiscalflags.AfterLoadDFMValues;
    WebClientDSfoneu01.AfterLoadDFMValues;
    WebClientDSativo.AfterLoadDFMValues;
    WebClientDSvia_acesso.AfterLoadDFMValues;
    WebClientDSsession.AfterLoadDFMValues;
    WebConn.AfterLoadDFMValues;
    WebDTS.AfterLoadDFMValues;
  end;
end;

end.
